import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    q: '¿Necesito experiencia previa?',
    a: 'No. El sistema está diseñado para empezar desde cero. El Tomo 1 cubre todo lo que necesitás saber antes de tu primer trabajo.'
  }, {
    q: '¿Funciona en mi ciudad?',
    a: 'Sí. El piso epoxi tiene demanda en todo el país: viviendas, cocheras, locales, galpones y espacios industriales.'
  }, {
    q: '¿Necesito herramientas costosas para empezar?',
    a: 'No. El programa te enseña exactamente qué comprar para el primer trabajo sin gastar de más. Podés arrancar con una inversión inicial accesible.'
  }, {
    q: '¿En cuánto tiempo recupero la inversión?',
    a: 'Una cochera promedio deja entre $35.000 y $65.000 de ganancia neta. El Mega Pack cuesta $29.990. Con un trabajo pequeño ya cubrís lo invertido.'
  }, {
    q: '¿Tengo acceso para siempre?',
    a: 'Sí. Acceso ilimitado y sin vencimiento. El contenido es tuyo.'
  }, {
    q: '¿Cómo consigo mis primeros clientes?',
    a: 'El Bono 2 cubre exactamente eso: un sistema práctico para generar consultas constantes desde el primer mes.'
  }];
  return <section className="py-16 px-4 bg-[#111]" aria-label="Preguntas frecuentes" data-id="element-68">
      <div className="max-w-3xl mx-auto" data-id="element-69">
        <h2 className="text-3xl md:text-4xl font-black text-center mb-12 text-white" data-id="element-70">
          Preguntas frecuentes
        </h2>

        <div className="space-y-4" role="list" data-id="element-71">
          {faqs.map((faq, index) => <div key={index} className="border border-gray-800 rounded-lg overflow-hidden" role="listitem" data-id="element-72">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-4 md:p-6 bg-[#1a1a1a] hover:bg-[#222] transition-colors text-left" aria-expanded={openIndex === index} aria-controls={`faq-answer-${index}`} id={`faq-question-${index}`} data-id="element-73">
                <span className="font-bold text-lg text-white" data-id="element-74">{faq.q}</span>
                {openIndex === index ? <ChevronUp className="w-5 h-5 text-amber-500 flex-shrink-0" aria-hidden="true" data-id="element-75" /> : <ChevronDown className="w-5 h-5 text-gray-500 flex-shrink-0" aria-hidden="true" data-id="element-76" />}
              </button>

              {openIndex === index && <div className="p-4 md:p-6 bg-[#141414] border-t border-gray-800" id={`faq-answer-${index}`} role="region" aria-labelledby={`faq-question-${index}`} data-id="element-77">
                  <p className="text-gray-300 text-lg" data-id="element-78">{faq.a}</p>
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}